const TopPanel = () => {

    return (
        <div className="bg-gray-150 text-gray-900 font-bold px-4 py-3">
            1 item added to your cart
        </div>
    )
};

export default TopPanel;